import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAnagraphicState } from './anagraphic';
import { ILoginState } from '../login/login';

const stateSelector = createFeatureSelector<IAnagraphicState>('anagraphic');
const loginSelector = createFeatureSelector<ILoginState>('login');

export const selectResponseAnagrafica = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseAnagrafica
);

export const selectResponseAddAnagrafica = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseAggiuntaAnagrafica
);

export const selectCurrentSiglaRete = createSelector(
  stateSelector,
  loginSelector,
  (state: IAnagraphicState, login: ILoginState) =>
    state.currentSiglaRete || login.utente?.siglaRt
);

export const selectResponseReteTerzaDettaglio = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseReteTerzaDettaglio
);

export const selectResponseEditReteTerzaDettaglio = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseModificaReteTerzaDettaglio
);

export const selectResponseInterfaceMonitoring = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseInterfaceMonitoring
);

export const selectResponseDocuments = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseDocuments
);

export const selectResponseCrmo = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseCrmo
);

export const selectResponseRisottomettiCrmo = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseRisottomettiCrm
);

export const selectResponseStoricoOperazioni = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseStoricoOperazioni
);

export const selectResponseSap = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseSap
);

export const selectResponseDashboard = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseDashboard
);

export const selectResponseRisottomettiSap = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseRisottomettiSap
);

export const selectResponseRisottomettiDashboard = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseRisottomettiDashboard
);

export const selectResponseInterfaceHistory = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseInterfaceHistory
);

export const selectResponseOperazioniProgressivo = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseOperazioniProgressivo
);

export const selectResponseNuovaOperazioneFile = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseNuovaOperazioneFile
);

export const selectResponseMal = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseMal
);

export const selectResponseRam = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseRam
);

export const selectResponseCd = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseCd
);

export const selectResponseListaGestionePunti = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseListaGestionePunti
);

export const selectResponseCambiostato = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseCambioStatoWithPayload
);

export const selectResponseCambiostatoPps = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseCambioStatoPpsWithPayload
);

export const selectResponseAttivazioneMassivaFile = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseAttivazioneMassivaFile
);

export const selectResponseConfermaAttivazioneMassivaFile = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseConfermaAttivazioneMassivaFile
);


export const selectResponseForzaturaPreAttivazioneFile = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responsePreAttivazioneFile
);

export const selectResponseConfermaForzaturaPreAttivazioneFile = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseConfermaPreAttivazioneFile
);

export const selectResponsePuntoPosteDetail = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responsePuntoPoste
);

export const selectResponseCMP = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseCMP
);

export const selectResponseAudit = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseAudit
);

export const selectResponseCP = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseCP
);

export const selectResponseReportGiacenzaList = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseReportGiacenzeList
);

export const selectResponseReportGiacenzaLockerList = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseReportGiacenzeLockerList,
);

export const selectResponseStoricoInterfacceSap = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseStoricoSap
);

export const selectResponseStoricoInterfacceDashboard = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseStoricoDashboard
);

export const selectResponseStoricoIcon = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseStoricoIcon
);

//Attivazione forzata servizi
export const selectResponseAttivazioneForzataServizi = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseAttivazioneForzataServizi
);

export const selectStatoAttivazioneForzataServizi = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.statoAttivazioneForzataServizi
);

export const attivazioneForzataServiziSuccessMessage = createSelector(
  stateSelector,
  (state: IAnagraphicState)  => state.attivazioneForzataServiziSuccessMessage
);

export const attivazioneForzataServiziErrorMessage = createSelector(
  stateSelector,
 (state: IAnagraphicState)  => state.attivazioneForzataServiziErrorMessage
);

export const selectResponseForzaAttivazioneServiziMassivaFile = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseForzaAttivazioneServiziMassivaFile
);

// CARICAMENTO MASSIVO FERIE
export const selectResponseUploadMassivoFerieFile = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseUploadMassivoFerieFile
);


export const selectResponseConfermaCaricamentoMassivoFileFerie = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseConfermaCaricamentoMassivoFileFerie
);

// caricamento massivo gestione utenze
export const selectResponseUploadMassivoGestioneUtenzeFile = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseUploadMassivoGestioneUtenzeFile
);


export const selectResponseConfermaCaricamentoMassivoFileGestioneUtenze = createSelector(
  stateSelector,
  (state: IAnagraphicState) => state.responseConfermaCaricamentoMassivoFileGestioneUtenze
);


